module.exports = __webpack_public_path__ + "static/media/32_tn.4cfd675b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/thumbnails/32_tn.jpg
// module id = 341
// module chunks = 0